module.exports = __webpack_public_path__ + "img/austria-ischemic-heart-disease-female.cdb46b44.png";